export default __webpack_public_path__ + "top-arrow-tealish.png?24d68c211e319d6120453ab4e5b39ad3";